/** @format */

import React, { useState, useEffect } from 'react';
import { Navigate as Redirect } from 'react-router-dom';
import { useStyles } from './style';
import { AuthService } from 'components/Auth';
import { getUrlParameter } from 'utility';
import { Grid, Typography, Button } from '@mui/material';
import get from 'lodash/get';
import { SnackbarFp, ButtonLoading, SimpleDialog, Icons } from 'components';
import { isBase64 } from 'validator';
import { SYS_ENVIRONMENT } from 'constant';
import { useQuery } from 'hooks';
import useCustomHook from './hooks';
import createToast from 'components/Toast/Toast';
import { useNavigate } from 'react-router-dom';
import { useBusinessDispatcher } from 'hooks';
const SignIn = (props) => {
  const query = useQuery();
  const {
    redirect,
    setRedirect,
    loading,
    setLoading,
    loadingOTP,
    setLoadingOTP,
  } = useCustomHook();
  const [openSnack, setOpenSnack] = useState(false);
  const [dataSnack, setDataSnack] = useState({
    txt: '',
    actions: '',
  });
  const [openDialog, setOpenDialog] = useState(false);
  const closeDialog = () => {
    setOpenDialog(false);
  };
  const classes = useStyles();
  const navigate = useNavigate();
  const setBusinessDispatcher = useBusinessDispatcher();
  useEffect(() => {
    isRedirectOtherSite();
    async function fetchToken(ssoCode) {
      localStorage.setItem('DataFetched', '0'); // ابتدا این فیلد پر میشود و تا زمانیکه دیتا نگیرد صفر است

      setLoading(true);
      try {
        if (localStorage.getItem('TOKEN')) {
          // زمانیکه کاربر اتولاگین انجام میدهد، درصورتی که از قبل لاگین شده باشد، توکن قبلی ریووک میشود
          await AuthService.revokeLogin();
        }
        let isRedirect = false;
        const env = process.env?.REACT_APP_ENVIRONMENT;
        await AuthService.fetchToken(ssoCode).then((res) => {
          if (env == 'development') {
            isRedirect = true;
          } else {
            if (!res) {
              setOpenDialog(true);
              isRedirect = false;
            } else {
              isRedirect = true;
            }
          }
        });
        if (isRedirect) {
          const b = await AuthService.fetchBusiness();
          localStorage.setItem('DataFetched', '1'); // هر زمان که سرویس پاسخ داد این فیلد 1 میشود و به این معنی است که دیتا برگشته
          setBusinessDispatcher(b.result);
          const REFRESH_TOKEN_KEY = 'LATEST_REFRESH_TOKEN';
          localStorage.setItem(REFRESH_TOKEN_KEY, `${new Date().getTime()}`);
          setRedirect(true);
        }
      } catch (error) {

        let dataError = error?.response?.data
        if (dataError?.status === 400 && dataError?.errorTypeCode === 103) {
          createToast('خطا', dataError?.message, 'danger');
          setTimeout(() => {
            AuthService.clearToken();
          }, 10);
        } else {
          setTimeout(() => {
            AuthService.clearToken();
          }, 10);
          createToast('خطا', dataError?.message ? dataError?.message : error?.message ? error?.message : 'خطا در برقراری ارتباط با سرور', 'danger');


        }
        // setError(true);
        setLoading(false);
      }
      setLoading(false);
    }

    const code = getUrlParameter('code') ?? null;
    const redirectUri = process.env?.REACT_APP_REDIRECT_URI;
    if (code) {
      const params = {
        redirectUri,
        code,
      };

      let newPanelRedirect = AuthService.getLastUserLocation();
      AuthService.removeLastUserLocation();

      try {
        const state = getUrlParameter('state');
        if (state && isBase64(state)) {
          let stateStr = decodeURIComponent(atob(state));
          stateStr = JSON.parse(stateStr);
          if (stateStr?.redirect_url) {
            newPanelRedirect = stateStr.redirect_url;
          } else {
            params.state = state;
          }
        } else if (state) {
          params.state = getUrlParameter('state');
        }
      } catch (error) { }

      if (newPanelRedirect) {
        localStorage.setItem('panel:redirect', newPanelRedirect);
      }
      fetchToken(params);
    }

    if (localStorage.getItem('panel:redirect') && !code) {
      //handleSignIn();
    }
  }, []);

  const isRedirectOtherSite = async () => {
    if (window.location.search == '') {
      localStorage.removeItem('destination');
    }
    if (
      query.get('auto_login_code') &&
      query.get('destination')
    ) {
      setLoading(true);
   
      let str = `&auto_login_code=${query.get('auto_login_code')}`;
      if (query.get('login_as_user_id')) {
        str += `&login_as_user_id=${query.get('login_as_user_id')}`;
      }
      try {
        const redirectUri = process.env?.REACT_APP_REDIRECT_URI;
        const param = { redirectUri };
        param.prompt = false;
        const response = await AuthService.getLoginUrl(param);
        setLoading(false);
        if (response.data) {
          let items = response.data.result.split('&');
          items = items.filter((a) => !a.includes('state='));
          let originalStr = items.join('&') + str;
          localStorage.setItem('destination', query.get('destination'));
          window.location.href = originalStr;
          //window.location.href = response.data.result + str;
        }
      } catch (error) {
        setLoading(false);
      }
    }
  };
  const handleSignIn = async () => {
    if (localStorage.getItem('TOKEN')) {
      // اگر تب های دیگه ای باز باشه و لاگین شده باشه
      navigate('/Home');
      return;
    }
    setLoading(true);
    try {
      const redirectUri = process.env?.REACT_APP_REDIRECT_URI;
      const param = { redirectUri };
      param.prompt = false;
      const response = await AuthService.getLoginUrl(param);
      setLoading(false);
      if (response.data) {
        window.location.href = response.data.result;
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSignInOTP = async () => {
    if (localStorage.getItem('TOKEN')) {
      // اگر تب های دیگه ای باز باشه و لاگین شده باشه
      navigate('/Home');
      return;
    }
    setLoadingOTP(true);
    try {
      const param = {};
      param.redirect_url = '';
      const response = await AuthService.getLoginOTP(param);
      setLoadingOTP(false);
      if (response.data) {
        window.location.href = response.data.result;
      }
    } catch (error) {
      setLoadingOTP(false);
    }
  };

  if (redirect) {
    let { from } = get(props, 'location.state', { from: { pathname: '/home' } });

    if (localStorage.getItem('panel:redirect')) {
      from = localStorage.getItem('panel:redirect');
    }

    return <Redirect to={from} />;
  }

  const registerLink = process.env?.REACT_APP_URL_REGISTER_BUSINESS;
  const oldPanelLink =
    SYS_ENVIRONMENT === 'production'
      ? 'https://panel.pod.ir/oldBusiness'
      : 'https://sandbox.pod.ir:9009/oldBusiness';

  return (
    <div className={classes.root}>
      <SnackbarFp data={dataSnack} open={openSnack} setOpenSnack={setOpenSnack} />
      <Grid className={classes.grid} container>
        <Grid className={classes.quoteContainer} item lg={5}>
          <div className={classes.quote}>
            <div className={classes.quoteInner}>
              <img
                alt="pod logo"
                src="./images/pod/main-english-white.svg"
                className={classes.logo}
              />
              <Typography className={classes.quoteText} variant="h1">
                مدیریت آنلاین کسب‌و‌کار
              </Typography>
            </div>
          </div>
        </Grid>
        <Grid className={classes.content} item lg={7} xs={12}>
          <div className={classes.content}>
            <div className={classes.contentBody}>
              <div className={classes.form}>
                <Typography className={classes.title} variant="h2">
                  ورود
                </Typography>
                <Typography color="textSecondary" gutterBottom>
                  ورود با سیستم یک‌پارچه احراز هویت پاد
                </Typography>
                <Grid className={classes.signInButton} container spacing={3}>
                  <Grid item lg={4}>
                    <ButtonLoading
                      name="ورود با رمز‌عبور"
                      loading={loading}
                      color="primary"
                      onClick={handleSignIn}
                      variant="contained"
                      startIcon={<Icons icon="Login" color="#fff" size="23" />}
                      disabled={loading}
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <ButtonLoading
                      name="ورود با رمز یک بار مصرف(OTP)"
                      loading={loadingOTP}
                      color="primary"
                      onClick={handleSignInOTP}
                      variant="contained"
                      startIcon={<Icons icon="Login" color="#fff" size="23" />}
                      disabled={loadingOTP}
                    />
                  </Grid>
                  <Grid item lg={12}>
                    <Typography color="textSecondary" variant="h6">
                      کاربر جدید هستید؟ &nbsp;
                      <a href={registerLink} className={classes.registerLink}>
                        ثبت نام
                      </a>
                    </Typography>
                  </Grid>
                  <Grid item lg={12} className={classes.loginHint}>
                    <Typography color="textSecondary" variant="h6">
                      <span className={classes.loginHintIcon}>
                        <Icons icon="Info" color="#919191cc" size="20" />
                      </span>
                      با حساب کسب‌وکاری خود وارد شوید.
                    </Typography>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      <SimpleDialog title=" هشدار" open={openDialog} onClose={closeDialog}>
        <Grid container style={{ textAlign: 'justify' }}>
          <div>
            <h4 style={{ marginTop: '15px' }}>کاربر گرامی</h4>
            <p style={{ marginTop: '5px', marginBottom: '20px' }}>
              جهت ورود به پنل کسب و کار می بایست سطح مالی خود را تا حداقل سطح 3 ارتقا دهید.
            </p>
          </div>
        </Grid>
        <Grid style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: '16px', gap: '15px', }}>
          <Button
            color="primary"
            variant="contained"
            style={{ marginLeft: '10px' }}
            onClick={() => window.open('https://levelup.wepod.ir/', '_blank')}
          >
            ارتقا سطح مالی
          </Button>
          <Button
            variant="contained"
            onClick={() => setOpenDialog(false)}
          >
            انصراف
          </Button>
        </Grid>
      </SimpleDialog>
    </div>
  );
};

export default SignIn;
